import { createContext, useContext } from "react";

interface UIContextInterface {
  displayBack: boolean;
  setDisplayBack: (value: boolean | ((prev: boolean) => boolean)) => void;
  loadingDashboard: boolean;
  setLoadingDashboard: (value: boolean | ((prev: boolean) => boolean)) => void;
  dashboardError: boolean;
  setDashboardError: (value: boolean | ((prev: boolean) => boolean)) => void;
}

const defaultUIState = {
  displayBack: false,
  setDisplayBack: (): boolean => false,
  loadingDashboard: false,
  setLoadingDashboard: (): boolean => false,
  dashboardError: false,
  setDashboardError: (): boolean => false,
};

const UIContext = createContext<UIContextInterface>(defaultUIState);

export const useUIContext = (): UIContextInterface => useContext(UIContext);

export default UIContext;
